import { render, staticRenderFns } from "./main-fluid.vue?vue&type=template&id=b093ecd6&"
import script from "./main-fluid.vue?vue&type=script&lang=js&"
export * from "./main-fluid.vue?vue&type=script&lang=js&"
import style0 from "./main-fluid.vue?vue&type=style&index=0&id=b093ecd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports